import React from 'react';
import { generatePath, matchPath, useLocation } from 'react-router-dom';
import { IconFormIcons, IconFormNames } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { SideNavigationItem } from 'shared/components/ui/side-navigation-item';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { Paths } from 'shared/routes/paths';
import { DraggableOptions } from 'shared/types/draggable-types';
import { SmartList } from 'shared/types/smart-list';

import * as Styled from './smart-list-side-menu-item.style';

type SmartListSideMenuItemProps = {
  smartList: SmartList;
  children?: React.ReactNode;
  isMoving?: boolean;
  hasDnd?: boolean;
  onContextMenu?: (e: React.MouseEvent) => void;
};

export const SmartListSideMenuItem = React.forwardRef<
  HTMLDivElement,
  SmartListSideMenuItemProps
>(({ smartList, children, isMoving, hasDnd, onContextMenu }, ref) => {
  const location = useLocation();
  const openPremiumDialog = useOpenPremiumDialog();
  const Container = hasDnd ? SortableContainer : React.Fragment;

  const containerProps = React.useMemo(
    () =>
      (hasDnd
        ? { id: smartList.id, type: DraggableOptions.SmartList }
        : {}) as SortableContainerProps,
    [hasDnd, smartList.id],
  );

  return (
    <Container {...containerProps}>
      <SideNavigationItem
        ref={ref}
        start={
          <Styled.IconContainer $color={smartList.color}>
            <Icon
              icon={IconFormIcons[smartList.icon || IconFormNames.SmartList]}
            />
          </Styled.IconContainer>
        }
        label={smartList.name}
        link={
          !!smartList.frozenAt
            ? undefined
            : generatePath(Paths.SmartListDetail, { id: smartList.id })
        }
        onClick={!!smartList.frozenAt ? openPremiumDialog : undefined}
        active={
          !smartList.frozenAt &&
          !!matchPath(
            generatePath(Paths.SmartListDetail, { id: smartList.id }),
            location.pathname,
          )
        }
        isMoving={isMoving}
        onContextMenu={onContextMenu}
      >
        {children}
      </SideNavigationItem>
    </Container>
  );
});
